import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SnackBarCloseBtn = ({ onClose }) => {
  return (
    <Button
      sx={{
        padding: 0,
        minWidth: '24px',
        color: 'inherit',
      }}
      onClick={onClose}
    >
      <CloseIcon
        sx={{
          color: 'inherit',
        }}
        fontSize="small"
      />
    </Button>
  );
};

SnackBarCloseBtn.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default SnackBarCloseBtn;
